'use strict';

var debounce = require('lodash/debounce');

var wishlist = require('../wishlist/wishlist.js');
var tileBase = require('core/product/tile');
var tileCarousel = require('./tileCarousel');

// PLP tile image carousel (site preference plpTileImageCarousel), built on the Bootstrap carousel already in the bundle
var TILE_CAROUSEL = '.tile-carousel';
var TILE_CAROUSEL_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAAAAACw=';

tileBase.methods.swatchSwitch = function(el) {
    var $swatch = el;
    var $tileParent = $swatch.parents('.product-tile');
    var pid = $tileParent.attr('data-pid');
    var $tileImage = $tileParent.find('.product-tile-image:not(.cloned-tile-image)');
    var $tileImageHover = $tileParent.find('.product-tile-image-secondary');
    var $tileImageContainer = $tileParent.find('.product-tile-image-container');

    $tileParent.find('.swatch.selected').removeClass('selected');
    $swatch.addClass('selected');

    var $carousel = $tileParent.find(TILE_CAROUSEL);
    var swatchSlides = $swatch.data('tile-slides'); // jQuery parses the JSON attribute

    // Image carousel enabled (plpTileImageCarousel): rebuild slides with the swatch color's images
    if ($carousel.length && Array.isArray(swatchSlides) && swatchSlides.length > 0) {
        tileBase.methods.tileCarouselSetSlides($carousel[0], swatchSlides);
    } else if ($swatch.data('hover-image') && $swatch.data('hover-image') != '') {
        // If swatch has image URL, use it to update current tile images
        // Clone current image element, keep it hidden until new images finish loading (prevents visual flashing)
        var $newTileImage = $tileImage.clone().removeAttr('loading'); // loading="lazy" images do not preload if display: none;
        $newTileImage.addClass('d-none cloned-tile-image');
        $newTileImage.insertAfter($tileImage);

        // Just after new image loads...
        $newTileImage.one('load', () => {
            // Replace image category class
            $tileImageContainer.removeClass('model-shot-tile product-shot-tile video-thumbnail-tile product-video-tile');
            if ($swatch.data('image-category')) {
                $tileImageContainer.addClass($swatch.data('image-category') + '-tile');
            }
            // Swap out old image with new one
            $tileImage.replaceWith($newTileImage.removeClass('d-none cloned-tile-image'));
        });

        // Replace main image and secondary image
        var swatchImageUrl = $swatch.data('hover-image');
        $newTileImage.attr('src', swatchImageUrl);
        if ($tileImageHover.length > 0 && $swatch.data('hover-image-secondary')) {
            var swatchSecondaryImageUrl = $swatch.data('hover-image-secondary');
            $newTileImage.data('alt-img-url', swatchSecondaryImageUrl);
            $tileImageHover.attr('src', swatchSecondaryImageUrl);
        }
    }

    //replace main link and Quickview link
    var swatchLink = $swatch.hasClass('swatch-link') ? $swatch : $swatch.parents('.swatch-link');
    var splitSwatchLink = swatchLink.attr('href').split('?');
    var swatchLinkAttributes = splitSwatchLink[1];
    // this is for the mainImageLink
    var mainImageQueryString = swatchLinkAttributes;
    // this is for the quickview
    var quickviewQueryString = swatchLinkAttributes;

    //  New for AB - need to account for pid being in the querystring
    if (swatchLinkAttributes.indexOf('pid') != -1) {
        // then split on &
        var queryStringArray = swatchLinkAttributes.split('&');
        var newQSArray = [];
        queryStringArray.forEach((queryAttr, _i) => {
            if (queryAttr.indexOf('pid') == -1) {
                newQSArray.push(queryAttr);
            }
        });
        // this is for the mainImageLink
        mainImageQueryString = swatchLinkAttributes;

        // this is for the quickview
        quickviewQueryString = newQSArray.join('&');
    }

    //main Image Link
    var mainImageLink = $tileParent.find('.product-tile-image-link');
    var mainImageLinkSplit = mainImageLink.attr('href').split('?');
    mainImageLink.attr('href', mainImageLinkSplit[0] + '?' + mainImageQueryString);

    //main Quickview Link
    var $mainQuickViewLink = $tileParent.find('a.quickview');
    if ($mainQuickViewLink.length) {
        var mainQuickViewLinkSplit = $mainQuickViewLink.attr('href').split('?');
        //this is assuming that every swatch link will not contain a pid in the attributes
        $mainQuickViewLink.attr('href',  mainQuickViewLinkSplit[0] + '?' + 'pid=' + pid + '&' + quickviewQueryString);
    }

    //main Wishlist Link
    if ($swatch.attr('data-wishlistpid')) {
        var $mainWishlistLink = $tileParent.find('a.wishlist');
        if ($mainWishlistLink.length) {
            $mainWishlistLink.attr('data-wishlistpid', $swatch.attr('data-wishlistpid'));

            // Make heart icon accurate
            wishlist.updateWishlistLinkData($mainWishlistLink);
        }
    } else {
        // swatch doesn't have one... so we either need to revert to master or just unset..., this may also work in the case of a variation-group

        var $mainWishlistLink = $tileParent.find('a.wishlist');
        if ($mainWishlistLink.length) {
            var swatchColorValue = $swatch.attr('data-color-value');
            wishlist.updateWishlistLinkData($mainWishlistLink, swatchColorValue);
        }
    }

    // Trigger custom event for swatch selected
    $('body').trigger('tile:swatchSelected', $swatch);
}

 try {
    // Recursive lazy loading images to prevent flashing when the img switches view
    const tileLazyImgAuto = debounce(
        (img = document.querySelector('img.product-tile-image-secondary[loading="lazy"]')) => img && (img.setAttribute('loading', 'eager') || tileLazyImgAuto()),
        500,
        { leading: false, trailing: true }
    );

    // Mutation action is debounced to prevent multiple rapid mutations from causing performance issues
    const injectionAlert = new MutationObserver(mutations => mutations?.forEach(m => m?.addedNodes?.length && tileLazyImgAuto()));
    injectionAlert.observe(document.body, { childList: true, subtree: true });
} catch (e) {
    // IntersectionObserver not supported and default lazy loading should be sufficient
}

// Tile carousel: swaps data-src -> src (and data-poster -> poster) for media in the given slides
tileBase.methods.tileCarouselLoad = function ($items) {
    $items.find('[data-src]').each(function () {
        if (this.dataset.poster) this.setAttribute('poster', this.dataset.poster);
        this.setAttribute('src', this.dataset.src);
        this.removeAttribute('data-src');
    });
};

// Tile carousel: toggles arrow availability (data-at-start/data-at-end) and plays only the active slide's video
tileBase.methods.tileCarouselSync = function (carousel) {
    var $items = $(carousel).find('.carousel-item');
    var index = $items.index($items.filter('.active'));

    carousel.setAttribute('data-at-start', index <= 0);
    carousel.setAttribute('data-at-end', index >= $items.length - 1);

    $items.find('video').each(function () {
        if ($(this).closest('.carousel-item').hasClass('active')) {
            var playing = this.play();
            if (playing && playing.catch) playing.catch(function () {});
        } else {
            this.pause();
        }
    });
};

// Tile carousel: creates the Bootstrap instance once and loads the next slide. Touch swipe is disabled for tiles
// inside a slider (the slider owns horizontal drags there; the tile arrows still work).
tileBase.methods.tileCarouselInit = function ($carousel) {
    if ($carousel.length && !$carousel.data('bs.carousel')) {
        $carousel.carousel({ touch: !$carousel.closest('.slider-container, .tns-outer').length });
        tileBase.methods.tileCarouselLoad($carousel.find('.carousel-item.active').next());
    }

    return $carousel;
};

// Tile carousel: replaces the slides with a swatch color's images
tileBase.methods.tileCarouselSetSlides = function (carousel, slides) {
    var $inner = $(carousel).find('.carousel-inner');
    if (!$inner.length || !Array.isArray(slides) || !slides.length) return false;

    var $first = $inner.find('.product-tile-image').first();

    $inner.empty().append(slides.map(function (slide, i) {
        var $media;
        if (i === 0) {
            $media = ($first.length ? $first.clone() : $('<img class="product-tile-image tile-image">')).removeAttr('loading').attr('src', slide.u);
        } else if (slide.v) {
            $media = $('<video class="tile-image" muted loop playsinline preload="none"></video>').attr({ 'data-src': slide.v, 'data-poster': slide.u });
        } else {
            $media = $('<img class="tile-image" decoding="async">').attr({ src: TILE_CAROUSEL_PLACEHOLDER, 'data-src': slide.u, alt: slide.a || '' });
        }

        return $('<div class="carousel-item"></div>').toggleClass('active', i === 0).append($media);
    }));

    tileBase.methods.tileCarouselLoad($inner.children().eq(1));
    $(carousel).closest('.product-tile-image-container')
        .removeClass('model-shot-tile product-shot-tile video-thumbnail-tile product-video-tile')
        .addClass(slides[0].c ? slides[0].c + '-tile' : '');
    tileBase.methods.tileCarouselSync(carousel);

    return true;
};

// Tile carousel init (run by processInclude). Listeners are delegated on document, so tiles appended via AJAX
// need no initialization, and call tileBase.methods at event time so each method can be extended per storefront.
tileBase.tileCarouselEvents = function () {
    var ns = '.tileCarousel ';

    $(document)
        .off(ns)
        // First interaction: create the instance and load the next slide
        .on('mouseenter' + ns + 'focusin' + ns + 'touchstart' + ns, '.product-tile', function () {
            tileBase.methods.tileCarouselInit($(this).find(TILE_CAROUSEL));
        })
        // Arrows (closest() instead of Bootstrap's data-target, so duplicate tiles on a page work)
        .on('click' + ns, TILE_CAROUSEL + ' [data-tile-carousel]', function (e) {
            e.preventDefault();
            tileBase.methods.tileCarouselInit($(this).closest(TILE_CAROUSEL)).carousel($(this).data('tile-carousel'));
        })
        // Load the incoming slide and the one after it before the slide animates in
        .on('slide.bs.carousel' + ns, TILE_CAROUSEL, function (e) {
            var $next = $(e.relatedTarget);
            tileBase.methods.tileCarouselLoad($next.add($next.next()));
        })
        .on('slid.bs.carousel' + ns, TILE_CAROUSEL, function () {
            tileBase.methods.tileCarouselSync(this);
        });
};

module.exports = tileBase;
